import { Component, Input } from '@angular/core';
import { BtImageModel } from '../bt-image.model';

@Component({
    selector: 'bt-image-design',
    templateUrl: './bt-image-design.component.html',
    styleUrls: ['./bt-image-design.component.scss']
})
export class BtImageDesignComponent {
    @Input() model: BtImageModel;
    @Input() value: any;
}